import styled, { css } from 'styled-components';

const Month = styled.div`
  ${(props) =>
    !props.selected &&
    css`
      cursor: pointer;

      &:hover > span {
        background-color: #d3d3d330;
        padding: 5px 10px;
        border-radius: 3px;
      }
    `}

  &:focus {
    outline: none;
  }

  ${(props) =>
    props.selected &&
    css`
      > span {
        background-color: #e8f3ff;
        color: ${({ theme }) => theme.colors.primary};
        font-weight: 500;
        padding: 5px 10px;
        border-radius: 3px;
      }
    `};

  transition: background-color 0.1s, color 0.1s;
  font-size: 14px;
  background-color: #fff;
  color: #888;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 33.33%;
`;

export default Month;
